<template>
  <div>

    <div class="row mt-4">
      <div class="col-md-8">
        <input class="input form-control"
               @keypress.enter="find()"
               v-model="query.generic"
               placeholder="Pesquisar por título ou conteúdo">
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button class="col-md-1 ml-2 btn-sm btn-outline"
              :class="{ 'btn-outline-active': showFilter }"
              @click="showFilter = !showFilter">
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{ 'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <div class="row">
      <div class="col-md-12">
        <BadgeFilters :query="query" @clearBadge="find()" @clearAllBadges="find()"
                      :amount-changed="updateNumberOfBadges"
                      :filters="[filterAccount, filterUser, filterPeriodType, filterStartDate, filterEndDate]"/>
      </div>
    </div>

    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-6">
          <label>Contas</label>
          <Select2 :options="filterAccount" v-model="query.accountId" title-load="Carregando contas..."/>
        </div>

        <div class="col-md-6">
          <label>Usuários</label>
          <Select2 :options="filterUser" v-model="query.userId" title-load="Carregando usuários..."/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="event-important">Tipo de data</label>
          <select v-model="query.periodType" id="event-important" class="form-control">
            <option value="">Criado em</option>
            <option value="updated_at">Lido em</option>
          </select>
        </div>
      </div>
    </template>
    <hr>

    <div class="row mt-2">
      <div class="col-md-12">
        <button @click="openModal()" class="btn btn-primary mt-1 mr-1">Criar Notificação</button>
      </div>
    </div>

    <div v-if="campaigns.length" class="row mt-3">
      <div class="col-md-12">
        <div class="card p-3">
          <div class="d-flex align-items-center mb-2">
            <strong class="mr-2">Comunicações</strong>
            <small class="text-muted">{{ liveCampaignsCount() }} ativa(s)/agendada(s) de {{ campaigns.length }}</small>
          </div>
          <div class="row">
            <div v-for="c in campaigns.slice(0, 12)" :key="c.id" class="col-md-4 mb-2">
              <div class="border rounded p-2 h-100">
                <div class="d-flex justify-content-between align-items-start">
                  <span class="text-truncate mr-2"><strong>{{ c.title }}</strong></span>
                  <span class="badge" :class="statusClass(c.status)">{{ statusLabel(c.status) }}</span>
                </div>
                <div class="small text-muted mt-1">
                  {{ c.status === 'bell' ? 'Sininho' : 'Pop-up' }} · {{ c.accounts }} conta(s) · {{ c.read }}/{{ c.sent }} lidas
                  <template v-if="whiteLabelLabel(c.detail)"> · {{ whiteLabelLabel(c.detail) }}</template>
                </div>
                <div class="d-flex justify-content-end mt-2" style="gap: 6px">
                  <button class="btn btn-outline btn-sm" @click="openModal(c)">Editar</button>
                  <button class="btn btn-outline-red btn-sm" @click="deleteCampaign(c)">Excluir</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">

        <div class="row mt-4">
          <div class="col-md-12">
            <strong>
              {{infoTotalModels}}
            </strong>
          </div>
        </div>

        <table class="table table-borderless table-align table-h51">
          <thead>
          <tr>
            <th class="nowrap">ID</th>
            <th class="nowrap">Conta</th>
            <th class="nowrap">Usuário</th>
            <th class="nowrap">Recurso</th>
            <th class="nowrap">Título</th>
            <th class="nowrap">Conteúdo</th>
            <th class="nowrap">Criado em</th>
            <th class="nowrap">Lido em</th>
            <th class="nowrap"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="notification in notifications" :key="notification.id">
            <td>{{ notification.id }}</td>
            <td>{{ getAccountName(notification) }}</td>
            <td>{{ getUserName(notification) }}</td>
            <td>{{ notification.resource }}</td>
            <td>{{ notification.title }}</td>
            <td v-html="notification.content"/>
            <td>{{ notification.createdAt | datetime }}</td>
            <td>{{ notification.updatedAt | datetime }}</td>
            <td>
              <div class="btn-group">
                <button @click="showDetail(notification)" class="btn btn-outline">
                  <eye-icon size="1.5x" class="icon-sm"/>
                </button>
                <button @click="destroy(notification)" class="btn btn-outline-red">
                  <trash-2-icon size="1.5x" class="icon-sm"/>
                </button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12 my-1">
            <Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
          </div>
        </div>

      </div>
    </div>

    <Modal v-model="showModal">
      <div slot="header">
        {{ editingCampaignId ? 'Editar comunicação' : 'Criar Notificação' }}
      </div>

      <div class="ann-composer">
        <div class="ann-composer-form">

          <div class="form-group" v-if="!editingCampaignId">
            <label>Modelos rápidos</label>
            <div class="preset-row">
              <button type="button" v-for="p in presets" :key="p.key"
                      class="btn btn-sm preset-btn"
                      :class="currentNotification.preset === p.key ? 'btn-primary' : 'btn-outline'"
                      @click="applyPreset(p)">
                {{ p.emoji }} {{ p.label }}
              </button>
            </div>
          </div>

          <div class="form-group">
            <label for="notification-title">Título</label>
            <input v-model="currentNotification.title" id="notification-title" class="form-control" @input="bumpPreview">
          </div>
          <div class="form-group">
            <label for="notification-content">Mensagem</label>
            <textarea v-model="currentNotification.content" id="notification-content" class="form-control" @input="bumpPreview"/>
          </div>

          <div class="form-group">
            <label>Exibição</label>
            <div class="display-toggle">
              <button type="button" class="btn btn-sm"
                      :class="!currentNotification.popup ? 'btn-primary' : 'btn-outline'"
                      @click="setDisplay(false)">🔔 Só sininho</button>
              <button type="button" class="btn btn-sm"
                      :class="currentNotification.popup ? 'btn-primary' : 'btn-outline'"
                      @click="setDisplay(true)">🖥️ Pop-up + sininho</button>
            </div>
          </div>

          <template v-if="!editingCampaignId">
            <div class="form-group">
              <label>Público</label>
              <div class="d-flex flex-column">
                <label class="mb-1">
                  <input type="radio" value="all" v-model="currentNotification.targetMode" class="mr-1">
                  Todos os usuários
                  <strong v-if="currentNotification.targetMode === 'all'" class="d-block text-danger">
                    Cuidado! Irá mandar notificações para todos os usuários da plataforma
                  </strong>
                </label>
                <label class="mb-1">
                  <input type="radio" value="account" v-model="currentNotification.targetMode" class="mr-1">
                  Conta específica (com usuários opcionais)
                </label>
                <label class="mb-1">
                  <input type="radio" value="apps" v-model="currentNotification.targetMode" class="mr-1">
                  Por produto (todas as contas com o produto ativo)
                </label>
              </div>
            </div>

            <template v-if="currentNotification.targetMode === 'account'">
              <div class="form-group">
                <label for="notification-account-id">Conta</label>
                <select v-if="filterAccount" v-model="currentNotification.accountId"
                        id="notification-account-id" class="form-control">
                  <option :value="option.value" v-for="option in filterAccount.table" :key="option.value">
                    {{ option.label }}
                  </option>
                </select>
                <input v-else disabled class="form-control" value="Carregando contas...">
              </div>
              <div class="form-group">
                <label for="notification-user-id">Usuários (opcional — vazio envia para toda a conta)</label>
                <Select2 v-if="filterUser" :options="filterUser" v-model="currentNotification.userIds" id="notification-user-id"/>
                <input v-else disabled class="form-control" value="Carregando usuários...">
              </div>
            </template>

            <div class="form-group" v-if="currentNotification.targetMode === 'apps'">
              <label>Produtos</label>
              <div>
                <label v-for="app in appOptions" :key="app.value" class="mr-3">
                  <input type="checkbox" :value="app.value" v-model="currentNotification.appNames" class="mr-1">
                  {{ app.label }}
                </label>
              </div>
            </div>

            <div class="form-group" v-if="currentNotification.targetMode === 'all' || currentNotification.targetMode === 'apps'">
              <label for="notification-white-label">Clientes white label</label>
              <select v-model="currentNotification.whiteLabel" id="notification-white-label" class="form-control">
                <option value="exclude">Não enviar</option>
                <option value="include">Enviar também</option>
                <option value="only">Somente white label</option>
              </select>
              <select v-if="currentNotification.whiteLabel === 'only'" v-model="currentNotification.partnerAccountId"
                      class="form-control mt-2">
                <option :value="null">Todas as marcas</option>
                <option :value="partner.id" v-for="partner in partnerAccounts" :key="partner.id">{{ partner.name }}</option>
              </select>
              <small v-if="currentNotification.whiteLabel === 'include'" class="text-danger">
                Atenção: as contas white label também recebem esta comunicação.
              </small>
              <small v-else-if="currentNotification.whiteLabel === 'only'" class="text-muted">
                Apenas contas white label recebem, de todas as marcas ou de uma marca específica.
              </small>
              <small v-else class="text-muted">
                Contas white label e as contas parceiras ficam de fora deste envio.
              </small>
            </div>
          </template>

          <div class="form-group" v-else>
            <small class="text-muted">Público definido na criação (não editável).</small>
          </div>

          <hr>

          <template v-if="currentNotification.popup">
            <div class="form-group">
              <label>Animação de abertura</label>
              <select v-model="currentNotification.animation" class="form-control" @change="bumpPreview">
                <option v-for="a in animationOptions" :value="a.value" :key="a.value">{{ a.label }}</option>
              </select>
            </div>
            <div class="row">
              <div class="col-md-4 form-group"><label>Cor de fundo</label>
                <input type="color" v-model="currentNotification.bgColor" class="form-control" @input="bumpPreview"></div>
              <div class="col-md-4 form-group"><label>Cor do texto</label>
                <input type="color" v-model="currentNotification.textColor" class="form-control" @input="bumpPreview"></div>
              <div class="col-md-4 form-group"><label>Cor de destaque</label>
                <input type="color" v-model="currentNotification.accentColor" class="form-control" @input="bumpPreview"></div>
            </div>
            <div class="form-group">
              <label>Imagem/banner (URL, opcional)</label>
              <input v-model="currentNotification.imageUrl" class="form-control" placeholder="https://..." @input="bumpPreview">
            </div>
            <div class="row">
              <div class="col-md-6 form-group"><label>Botão (texto)</label>
                <input v-model="currentNotification.ctaText" class="form-control" @input="bumpPreview"></div>
              <div class="col-md-6 form-group"><label>Botão (link)</label>
                <input v-model="currentNotification.ctaLink" class="form-control"></div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group"><label>Posição</label>
                <select v-model="currentNotification.position" class="form-control" @change="bumpPreview">
                  <option value="center">Centro</option>
                  <option value="bottom-right">Canto inferior</option>
                </select>
              </div>
              <div class="col-md-6 form-group"><label>Frequência</label>
                <select v-model="currentNotification.frequency" class="form-control">
                  <option value="once">Uma vez (até fechar)</option>
                  <option value="session">Toda sessão (até expirar)</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group"><label>Início (opcional)</label>
                <input type="datetime-local" v-model="currentNotification.startsAt" class="form-control"></div>
              <div class="col-md-6 form-group"><label>Fim (opcional)</label>
                <input type="datetime-local" v-model="currentNotification.expiresAt" class="form-control"></div>
            </div>
            <div class="form-group">
              <input type="checkbox" v-model="currentNotification.confetti" id="notification-confetti" class="mr-2" @change="bumpPreview">
              <label for="notification-confetti">Confete ao abrir 🎉</label>
            </div>
          </template>
        </div>

        <div class="ann-composer-preview" v-if="currentNotification.popup">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="mb-0">Pré-visualização</label>
            <button type="button" class="btn btn-link btn-sm p-0" @click="bumpPreview">↻ Reproduzir</button>
          </div>
          <div class="preview-stage">
            <div :key="previewKey" class="preview-card" :class="'anim-' + currentNotification.animation"
                 :style="{ backgroundColor: currentNotification.bgColor, color: currentNotification.textColor }">
              <div v-if="currentNotification.confetti" class="confetti">
                <i v-for="n in 24" :key="n" class="confetti-piece"
                   :style="confettiStyle(n)"></i>
              </div>
              <div v-if="currentNotification.imageUrl" class="preview-image"
                   :style="{ backgroundImage: 'url(' + currentNotification.imageUrl + ')' }"></div>
              <div class="preview-body">
                <div class="preview-title">{{ currentNotification.title || 'Título da comunicação' }}</div>
                <div class="preview-content" v-html="currentNotification.content || 'Sua mensagem aparece aqui...'"></div>
                <span v-if="currentNotification.ctaText" class="preview-cta"
                      :style="{ backgroundColor: currentNotification.accentColor }">{{ currentNotification.ctaText }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group mt-3">
        <button @click="showModal = false" class="btn btn-outline btn-lg mr-2">Cancelar</button>
        <button @click="save()" class="btn btn-primary btn-lg">Salvar</button>
      </div>
    </Modal>

    <ShowDataModal
      v-if="currentDetail"
      v-model="showDetailModal"
      :header="currentDetail.title"
      :data="currentDetail"
      :deep="2"
    />

  </div>
</template>

<script>
  import BadgeFilters from '@/components/shares/BadgeFilters'
  import Modal from '@/components/shares/specialTag/Modal'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import Select2 from '@/components/shares/Select2'
  import ShowDataModal from '@/components/admin/ShowDataModal'
  import { ChevronDownIcon, EyeIcon, SearchIcon, Trash2Icon } from 'vue-feather-icons'
  import { Filter } from '@/models/filter'

  export default {
    components: { BadgeFilters, ChevronDownIcon, EyeIcon, Modal, Pagination, SearchIcon, Select2, ShowDataModal, Trash2Icon },
    computed: {
      notifications() {
        return this.models
      }
    },
    created() {
      this.$set(this.query, 'periodType', '')
      this.addOrderBy('createdAt', 'desc')
      this.includes.push('account', 'user')

      this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
      this.filterUser = this.buildFilterUser(this.allUsers.data)
      this.loadPartnerAccounts()

      this.defaultModelSetting.updateQueryURL = true
      this.asyncTemplateSelect({
        byURL: true,
        pagination: true
      })

      this.loadCampaigns()
    },
    data() {
      return {
        campaigns: [],
        editingCampaignId: null,
        currentDetail: null,
        currentNotification: {},
        previewKey: 0,
        filterAccount: null,
        filterEndDate: new Filter({
          key: 'endDate',
          label: 'Data final',
          type: 'date'
        }),
        filterPeriodType: new Filter({
          key: 'periodType',
          label: 'Tipo de data',
          table: [['Criado em', ''], ['Lido em', 'updated_at']]
        }),
        filterStartDate: new Filter({
          key: 'startDate',
          label: 'Data inicial',
          type: 'date'
        }),
        filterUser: null,
        partnerAccounts: [],
        modelPathPrefix: 'admin',
        nameModel: 'Notification',
        appOptions: [
          { value: 'cm-frotas', label: 'Caça-Multas Frotas' },
          { value: 'cm-embarcador', label: 'Caça-Multas Embarcador' },
          { value: 'cm-taxas', label: 'Caça-Taxas' },
          { value: 'cm-crono', label: 'Cronotacógrafo' },
          { value: 'dfe', label: 'DF-e' }
        ],
        animationOptions: [
          { value: 'fade', label: 'Fade' },
          { value: 'slide-up', label: 'Slide (baixo)' },
          { value: 'slide-right', label: 'Slide (lado)' },
          { value: 'zoom', label: 'Zoom' },
          { value: 'bounce', label: 'Bounce' },
          { value: 'flip', label: 'Flip' }
        ],
        presets: [
          { key: 'novidade', label: 'Novidade', emoji: '✨', content: 'Temos uma novidade pra você. Confira agora!',
            detail: { animation: 'slide-up', bgColor: '#0F172A', textColor: '#FFFFFF', accentColor: '#6366F1', ctaText: 'Conferir', position: 'center', frequency: 'once', confetti: false } },
          { key: 'lancamento', label: 'Lançamento', emoji: '🚀', content: 'Acabou de chegar! Conheça o novo recurso da plataforma.',
            detail: { animation: 'bounce', bgColor: '#111827', textColor: '#FFFFFF', accentColor: '#22C55E', ctaText: 'Ver novidade', position: 'center', frequency: 'once', confetti: true } },
          { key: 'manutencao', label: 'Manutenção', emoji: '🛠️', content: 'Faremos uma manutenção programada. Fique atento aos horários.',
            detail: { animation: 'fade', bgColor: '#1F2937', textColor: '#FFFFFF', accentColor: '#F59E0B', ctaText: 'Entendi', position: 'bottom-right', frequency: 'session', confetti: false } },
          { key: 'promocao', label: 'Promoção', emoji: '🎉', content: 'Oferta especial por tempo limitado. Não perca!',
            detail: { animation: 'zoom', bgColor: '#4C1D95', textColor: '#FFFFFF', accentColor: '#EC4899', ctaText: 'Aproveitar', position: 'center', frequency: 'session', confetti: true } }
        ],
        showDetailModal: false,
        showFilter: false,
        showModal: false
      }
    },
    inject: ['allAccounts', 'allUsers', 'buildFilterAccount', 'getAccountName'],
    methods: {
      loadCampaigns() {
        this.axios.get('admin/notifications/campaigns')
          .then((res) => {
            const d = (res && res.data) || []
            this.campaigns = Array.isArray(d) ? d : (d.data || [])
          })
          .catch(() => {})
      },
      loadPartnerAccounts() {
        this.axios.get('admin/accounts?q[account_type]=partner&meta=false&per_page=10000')
          .then((res) => {
            const d = (res && res.data) || []
            this.partnerAccounts = Array.isArray(d) ? d : (d.data || [])
          })
          .catch(() => {})
      },
      whiteLabelLabel(detail) {
        const d = detail || {}
        const mode = d.whiteLabel || d.white_label
        if (mode === 'exclude') return 'Sem white label'
        if (mode === 'include') return 'Inclui white label'
        if (mode !== 'only') return null
        const partnerId = d.partnerAccountId || d.partner_account_id
        if (!partnerId) return 'Só white label'
        const partner = this.partnerAccounts.find(p => Number(p.id) === Number(partnerId))
        return `Só white label: ${partner ? partner.name : '#' + partnerId}`
      },
      liveCampaignsCount() {
        return this.campaigns.filter(c => c.status === 'active' || c.status === 'scheduled').length
      },
      statusLabel(s) {
        return { active: 'Ativa', scheduled: 'Agendada', expired: 'Expirada', bell: 'Sininho' }[s] || s
      },
      statusClass(s) {
        return { active: 'badge-success', scheduled: 'badge-warning', expired: 'badge-secondary', bell: 'badge-info' }[s] || 'badge-secondary'
      },
      buildFilterUser(users) {
        return new Filter({
          key: 'userId',
          label: 'Usuário',
          table: users.map(u => [u.email, u.id])
        })
      },
      getUserName(notification) {
        const user = notification.user
        if (user)
          return user.email

        if (notification.userId) {
          const found = this.allUsers.data.find(u => u.id.toString() === notification.userId.toString())
          return (found && found.email) || `Usuário [${notification.userId}]`
        }
      },
      destroy(notification) {
        if (!confirm('Tem certeza?'))
          return

        this.asyncTemplateDelete(notification, {
          after: () => {
            this.$notify.add('Notificação apagada!')
            this.find()
          }
        })
      },
      find() {
        this.asyncTemplateSelect()
      },
      showDetail(notification) {
        this.currentDetail = notification
        this.showDetailModal = true
      },
      bumpPreview() {
        this.previewKey += 1
      },
      setDisplay(popup) {
        this.currentNotification.popup = popup
        this.bumpPreview()
      },
      confettiStyle(n) {
        const i = n - 1
        return {
          left: ((i * 4.17) % 100) + '%',
          backgroundColor: i % 2 ? (this.currentNotification.accentColor || '#22C55E') : '#FFFFFF',
          animationDelay: ((i % 8) * 0.05) + 's',
          animationDuration: (1.6 + (i % 5) * 0.2) + 's'
        }
      },
      applyPreset(preset) {
        const d = preset.detail
        this.currentNotification.preset = preset.key
        this.currentNotification.popup = true
        this.currentNotification.animation = d.animation
        this.currentNotification.bgColor = d.bgColor
        this.currentNotification.textColor = d.textColor
        this.currentNotification.accentColor = d.accentColor
        this.currentNotification.ctaText = d.ctaText
        this.currentNotification.position = d.position
        this.currentNotification.frequency = d.frequency
        this.currentNotification.confetti = !!d.confetti
        if (!this.currentNotification.title) this.currentNotification.title = preset.label
        if (!this.currentNotification.content) this.currentNotification.content = preset.content
        this.bumpPreview()
      },
      openModal(campaign = null) {
        if (campaign) {
          const d = campaign.detail || {}
          this.editingCampaignId = campaign.id
          this.currentNotification = {
            preset: null,
            title: campaign.title, content: campaign.content, resource: 'announcement', all: false, targetMode: null,
            accountId: null, userIds: [], appNames: [], whiteLabel: 'exclude', partnerAccountId: null,
            popup: (d.displayType || d.display_type || 'popup') === 'popup',
            animation: d.animation || 'slide-up', bgColor: d.bgColor || '#0F172A', textColor: d.textColor || '#FFFFFF',
            accentColor: d.accentColor || '#6366F1', imageUrl: d.imageUrl || '', ctaText: d.ctaText || '', ctaLink: d.ctaLink || '',
            position: d.position || 'center', frequency: d.frequency || 'once', confetti: !!d.confetti,
            startsAt: d.startsAt || d.starts_at || '', expiresAt: d.expiresAt || d.expires_at || ''
          }
        } else {
          this.editingCampaignId = null
          this.currentNotification = {
            preset: null,
            title: '', content: '', resource: 'announcement', all: false, targetMode: null,
            accountId: null, userIds: [], appNames: [], whiteLabel: 'exclude', partnerAccountId: null,
            popup: true, animation: 'slide-up', bgColor: '#0F172A', textColor: '#FFFFFF',
            accentColor: '#6366F1', imageUrl: '', ctaText: '', ctaLink: '',
            position: 'center', frequency: 'once', confetti: false,
            startsAt: '', expiresAt: ''
          }
        }
        this.bumpPreview()
        this.showModal = true
      },
      deleteCampaign(c) {
        if (!confirm(`Excluir a comunicação "${c.title}"? Essa ação não pode ser desfeita.`)) return
        this.axios.delete(`/admin/notifications/campaigns/${c.id}`)
          .then(() => { this.$notify.add('Comunicação excluída!'); this.loadCampaigns(); this.find() })
          .catch(err => this.$notify.addError(err))
      },
      buildDetail(cn) {
        if (!cn.popup) return { displayType: 'bell' }
        const detail = {
          displayType: 'popup',
          animation: cn.animation || 'fade',
          bgColor: cn.bgColor || '#0F172A',
          textColor: cn.textColor || '#FFFFFF',
          accentColor: cn.accentColor || '#6366F1',
          imageUrl: cn.imageUrl,
          ctaText: cn.ctaText,
          ctaLink: cn.ctaLink,
          position: cn.position || 'center',
          frequency: cn.frequency || 'once',
          confetti: !!cn.confetti,
          dismissible: true
        }
        if (cn.startsAt) detail.startsAt = cn.startsAt
        if (cn.expiresAt) detail.expiresAt = cn.expiresAt
        return detail
      },
      save() {
        const cn = this.currentNotification

        if (!cn.title || !cn.title.trim()) {
          this.$notify.addError('Informe o título da comunicação.')
          return
        }
        if (!cn.content || !cn.content.trim()) {
          this.$notify.addError('Informe a mensagem da comunicação.')
          return
        }

        const detail = this.buildDetail(cn)

        if (this.editingCampaignId) {
          this.axios.put(`/admin/notifications/campaigns/${this.editingCampaignId}`, {
            title: cn.title, content: cn.content, detail
          })
            .then(() => {
              this.$notify.add('Comunicação atualizada!')
              this.loadCampaigns(); this.find(); this.showModal = false; this.editingCampaignId = null
            })
            .catch(err => this.$notify.addError(err))
          return
        }

        if (!cn.targetMode) {
          this.$notify.addError('Escolha o público: "Todos os usuários", "Conta específica" ou "Por produto".')
          return
        }
        if (cn.targetMode === 'account' && !cn.accountId) {
          this.$notify.addError('Selecione a conta que receberá a comunicação.')
          return
        }
        if (cn.targetMode === 'apps' && !(cn.appNames && cn.appNames.length)) {
          this.$notify.addError('Selecione ao menos um produto.')
          return
        }

        const notification = {
          title: cn.title,
          content: cn.content,
          resource: cn.resource || 'announcement',
          detail
        }

        if (cn.targetMode === 'apps') {
          notification.appNames = cn.appNames
        } else if (cn.targetMode === 'all') {
          notification.all = true
        } else {
          notification.accountId = cn.accountId
          if (cn.userIds && cn.userIds.length) notification.userIds = cn.userIds
        }

        if (cn.targetMode !== 'account') {
          notification.whiteLabel = cn.whiteLabel || 'exclude'
          if (cn.whiteLabel === 'only' && cn.partnerAccountId) notification.partnerAccountId = cn.partnerAccountId
        }

        this.asyncTemplateSave(notification, {
          after: () => {
            this.$notify.add('Noticação criada!')
            this.loadCampaigns()
            this.find()
            this.showModal = false
          }
        })
      }
    },
    mixins: [ModelMapper],
    name: 'Notification',
    watch: {
      allAccounts: {
        deep: true,
        handler(value) {
          this.filterAccount = this.buildFilterAccount(value.data)
        }
      },
      allUsers: {
        deep: true,
        handler(value) {
          this.filterUser = this.buildFilterUser(value.data)
        }
      }
    }
  }
</script>

<style scoped>
  .rotate-90 {
    transform: rotate(180deg);
  }

  .fa-angle-right {
    transition: transform .2s;
    margin-left: 8px;
  }

  .preset-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .preset-btn {
    border-radius: 999px;
  }

  .display-toggle {
    display: flex;
    gap: 8px;
  }

  .ann-composer {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
  }

  @media (min-width: 992px) {
    .ann-composer {
      grid-template-columns: 1fr 320px;
      align-items: start;
    }
  }

  .ann-composer-preview {
    position: sticky;
    top: 8px;
  }

  .preview-stage {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 260px;
    padding: 16px;
    border: 1px dashed #cbd5e1;
    border-radius: 12px;
    background: rgba(148, 163, 184, 0.08);
  }

  .preview-card {
    position: relative;
    width: 100%;
    max-width: 280px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  }

  .preview-image {
    height: 96px;
    width: 100%;
    background-size: cover;
    background-position: center;
  }

  .preview-body {
    padding: 18px;
  }

  .preview-title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 6px;
  }

  .preview-content {
    font-size: 13px;
    opacity: 0.92;
  }

  .preview-content >>> a {
    text-decoration: underline;
  }

  .preview-cta {
    margin-top: 14px;
    display: inline-flex;
    border-radius: 8px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
  }

  .confetti {
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 2;
  }

  .confetti-piece {
    position: absolute;
    top: -20px;
    width: 8px;
    height: 8px;
    border-radius: 2px;
    animation-name: annConfetti;
    animation-timing-function: ease-in;
    animation-fill-mode: both;
  }

  @keyframes annConfetti {
    from { transform: translateY(0) rotate(0); opacity: 1; }
    to { transform: translateY(300px) rotate(360deg); opacity: 0; }
  }

  .anim-fade { animation: annFade 0.35s ease both; }
  .anim-slide-up { animation: annSlideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) both; }
  .anim-slide-right { animation: annSlideRight 0.4s cubic-bezier(0.16, 1, 0.3, 1) both; }
  .anim-zoom { animation: annZoom 0.35s cubic-bezier(0.16, 1, 0.3, 1) both; }
  .anim-bounce { animation: annBounce 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both; }
  .anim-flip { animation: annFlip 0.5s cubic-bezier(0.16, 1, 0.3, 1) both; }
  @keyframes annFade { from { opacity: 0; } to { opacity: 1; } }
  @keyframes annSlideUp { from { opacity: 0; transform: translateY(48px); } to { opacity: 1; transform: none; } }
  @keyframes annSlideRight { from { opacity: 0; transform: translateX(-48px); } to { opacity: 1; transform: none; } }
  @keyframes annZoom { from { opacity: 0; transform: scale(0.85); } to { opacity: 1; transform: scale(1); } }
  @keyframes annBounce { 0% { opacity: 0; transform: scale(0.6); } 60% { opacity: 1; transform: scale(1.05); } 100% { transform: scale(1); } }
  @keyframes annFlip { from { opacity: 0; transform: perspective(600px) rotateX(-90deg); } to { opacity: 1; transform: perspective(600px) rotateX(0); } }
</style>
